<template>
    <div>
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Transporteurs</h1>
                    <p>Gestion des méthodes de paiements</p>
                </div>

                <div class="actions">
                    <ul>
                        <li><button><span>Importer</span></button></li>
                        <li><button class="bt-primary" @click="create()"><i class="icon icon-icon_person-add"></i><span>Créer</span></button></li>
                    </ul>
                </div>

            </div>
        </header>
        <div class="content-body">

            <section>
            <div class="search">
                <div><input type="text" placeholder="Recherche" v-model="query"/></div>
                <!--
                <div>
                    <ul>
                        <li><button><span>Menu 1</span></button></li>
                        <li><button><span>Menu 1</span></button></li>
                        <li><button><span>Menu 1</span></button></li>
                    </ul>
                </div>
                -->
            </div>

            <h2 class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</h2>

            <div class="datagrid" :class="paginator.listing">
                <div class="datagrid-header">
                    <div>
                        <div></div>
                        <div class="picture"></div>
                        <div v-bind:class="[ paginator.sort == 'name' ? 'active' : '', paginator.order ]">
                            <span data-sort="name" @click="setOrder($event)">Nom</span>
                        </div>
                        <div v-bind:class="[ paginator.sort == 'ref' ? 'active' : '', paginator.order ]">
                            <span data-sort="ref" @click="setOrder($event)">ref</span>
                        </div>
                        <div><span>Statut</span></div>
                        <div><span>Scopes</span></div>
                        <div class="actions"></div>
                        <div></div>
                    </div>
                </div>
                <div class="datagrid-body">
                    <div v-for="item in resources" @dblclick="edit(item.id)">
                        <div></div>
                        <div class="picture no-radius">
                            <figure>
                                <i v-if="!item.picture" class="icon icon-icon_truck-delivery-time" style="font-size: 1.5em;"></i>
                                <img v-if="item.picture" :src="item.picture.url+'/resize/100x100'"/>
                            </figure>
                        </div>
                        <div data-field="name"><strong>{{ item.name }}</strong><p>{{ item.headline }}</p></div>
                        <div data-field="ref">{{ item.slug }}</div>
                        <div data-field="scope"><scopes v-model="item.scopes" v-if="item.scopes"></scopes></div>
                        <div class="actions">
                            <ul>
                                <li><button @click="remove(item.id)"><i class="icon icon-icon_delete"></i></button></li>
                                <li><button @click="edit(item.id)"><i class="icon icon-icon_pencil"></i></button></li>
                            </ul>
                        </div>
                        <div></div>
                    </div>
                </div>
            </div>
            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import TransporterService from './TransporterService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return {name: 'transporter', api: TransporterService};
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/config/transporter/Index.vue